import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './FormSection.scss'

const FormSection = ({
	children,
	right,
	dirty,
	dark,
	highlighted,
	...rest
}) => {
	const isDirty = dirty ? styles.dirty : ''
	const isDark = dark ? styles.dark : ''
	const isHighlighted = highlighted ? styles.highlighted : ''
	return (
		<div
			styleName={right ? 'section-right' : 'section'}
			className={[isDirty, isDark, isHighlighted].join(' ')}
		>
			{children}
		</div>
	)
}
FormSection.propTypes = {
	children: React.PropTypes.node
}

export default CSSModules(FormSection, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Form/FormSection.js